import {
  createBlocksModel,
  WidgetPropertyType,
} from '@wix/yoshi-flow-editor/blocks';

export default createBlocksModel({
  widgetName: 'NoteWidget',
  props: {
    label: {
      type: WidgetPropertyType.STRING,
      defaultValue: '',
    },
    maxLength: {
      type: WidgetPropertyType.NUMBER,
      defaultValue: 100,
    },
    placeholder: {
      type: WidgetPropertyType.STRING,
      defaultValue: '',
    },
    campaignId: {
      type: WidgetPropertyType.STRING,
      defaultValue: '',
    },
    shouldShowTitle: {
      type: WidgetPropertyType.BOOLEAN,
      defaultValue: true,
    },
  },
  methods: {
    focus: {},
    isValid: {},
    getValue: {},
    reset: {},
  },
  events: {
    change: {},
  },
});
